import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";               // 👈 Use App.js for routing & pages
import "./styles.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import { PopupProvider } from "./context/PopupContext";
import { isInstalledPwa, markPwaInstalled } from "./utils/pwaUtils";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <PopupProvider>
        <LanguageProvider>
          <App />
        </LanguageProvider>
      </PopupProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();

if (isInstalledPwa()) {
  markPwaInstalled();
}

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/sw.js`)
      .then((reg) => {
        reg.update().catch(() => {});
        if (isInstalledPwa() && reg.waiting) {
          reg.waiting.postMessage({ type: "SKIP_WAITING" });
        }
        reg.addEventListener("updatefound", () => {
          const worker = reg.installing;
          if (!worker || !isInstalledPwa()) return;
          worker.addEventListener("statechange", () => {
            if (worker.state === "installed" && navigator.serviceWorker.controller) {
              reg.waiting?.postMessage({ type: "SKIP_WAITING" });
            }
          });
        });
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") reg.update().catch(() => {});
        });
        window.setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
      })
      .catch(() => {});
  });
}
